module.exports = __webpack_public_path__ + "img/合成-1_3.7e6c6528.gif";